import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { SharedUiModule } from '@mode/shared/ui';
import { PdfExportDialogService } from './pdf-export-dialog-service';
import { PdfExportDialogComponent } from './pdf-export-dialog.component';

@NgModule({
  imports: [CommonModule, SharedUiModule, IconComponent, ButtonComponent],
  declarations: [PdfExportDialogComponent],
  providers: [PdfExportDialogService],
})
export class ReportViewerPdfExportFeatureDialogModule {
  constructor(
    pdfExportDialogService: PdfExportDialogService // Initialize pdf export dialog service to listen for open dialog requests
  ) {}
}
